import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function roleComboReducer(state= initialState.roleCombo, action){
	switch(action.type){
		case types.GET_ROLES_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}